import { connect } from 'react-redux';

const mapStateToProps = state => ({
  selectedLocations: state.mainreducer.selectedLocations,
});

export default PrivatePolicyPageRightPart => connect(mapStateToProps, null)(PrivatePolicyPageRightPart);
